export const GENDER = [
    { value: 'masculino'},
    { value: 'femenino'},
    { value: 'noBinario'},
    { value: 'otro'},
    { value: 'sinEspecificar'},
]